import { Button } from 'components/ui/button';
import { useWalkthrough } from 'modules/walkthrough/context';
import { Modal, Text } from 'ui';
import { SUPPORT_EMAIL, SUPPORT_URL } from '../../../constants';

interface IProps {
  onRequestClose: () => void;
  isOpen: boolean;
}

/**
 * Information to users on helpdesk/authentise articles and common queries.
 */
const CustomerSupportModal = ({ onRequestClose, isOpen }: IProps) => {
  const { reset } = useWalkthrough();

  const restartWalkthrough = () => {
    onRequestClose();
    reset();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      variant="center"
      contentLabel="threadsSupport"
      name="Threads Support"
    >
      <div>
        <Text size="md">
          Explore our comprehensive collection of{' '}
          <a
            target="_blank"
            href={SUPPORT_URL}
            rel="noreferrer"
            className="font-bold text-link underline"
          >
            Threads user articles
          </a>{' '}
          to find answers to common queries.
        </Text>
        <br />
        <Text size="md">
          Still can&apos;t find what you&apos;re looking for? Reach out to us directly via email at{' '}
          <a className="font-bold text-link underline" href={`mailto:${SUPPORT_EMAIL}`}>
            support@authentise.com
          </a>
          , and our dedicated team will get back to you as soon as possible.
        </Text>
        <div className="mt-4 flex  w-full flex-row justify-center">
          <Button onClick={restartWalkthrough}>Restart Walkthrough</Button>
        </div>
      </div>
    </Modal>
  );
};

export default CustomerSupportModal;
